import React, { useEffect, useState } from 'react';
import { useParams, useNavigate } from 'react-router-dom';
import axios from 'axios';

function EditEnergyOfficialsPage() {
  const { id: official_id } = useParams(); // Get official ID from URL
  const navigate = useNavigate();

  const [formData, setFormData] = useState({
    renergy_officials_name: '',
    renergy_officials_designation: '',
    renergy_officials_email: '',
    renergy_phone: '',
  });

  const [loading, setLoading] = useState(true);
  const [errors, setErrors] = useState({});
  const [successMessage, setSuccessMessage] = useState('');

  // Fetch existing official data
  useEffect(() => {
    const fetchOfficial = async () => {
      try {
        const res = await axios.get(`https://backend-zkgn.onrender.com/api/renewable_officials/view/${official_id}`);
        if (res.data) {
          setFormData({
            renergy_officials_name: res.data.renergy_officials_name || '',
            renergy_officials_designation: res.data.renergy_officials_designation || '',
            renergy_officials_email: res.data.renergy_officials_email || '',
            renergy_phone: res.data.renergy_phone || '',
          });
        }
      } catch (error) {
        console.error('Error fetching official:', error);
      } finally {
        setLoading(false);
      }
    };

    fetchOfficial();
  }, [official_id]);

  // Handle input changes
  const handleChange = (e) => {
    const { name, value } = e.target;
    setFormData({ ...formData, [name]: value });
  };

  // Validation
  const validate = () => {
    let tempErrors = {};
    let isValid = true;

    if (!formData.renergy_officials_designation.trim()) {
      tempErrors.renergy_officials_designation = 'Designation is required.';
      isValid = false;
    }
    if (!formData.renergy_officials_name.trim()) {
      tempErrors.renergy_officials_name = "Official's name is required.";
      isValid = false;
    }
    if (formData.renergy_officials_email && !/\S+@\S+\.\S+/.test(formData.renergy_officials_email)) {
      tempErrors.renergy_officials_email = 'Enter a valid email address.';
      isValid = false;
    }
    if (formData.renergy_phone && !/^[0-9]{10}$/.test(formData.renergy_phone)) {
      tempErrors.renergy_phone = 'Enter a valid 10-digit phone number.';
      isValid = false;
    }

    setErrors(tempErrors);
    return isValid;
  };

  // Submit form
  const handleSubmit = async (e) => {
    e.preventDefault();
    if (!validate()) return;

    try {
      await axios.put(`https://backend-zkgn.onrender.com/api/renewable_officials/update/${official_id}`, formData);
      setSuccessMessage('Official updated successfully!');
      setTimeout(() => navigate(-1), 2000); // Navigate back after 2 sec
    } catch (error) {
      console.error('Error updating official:', error.response?.data || error);
      setErrors({ api: 'Failed to update official. Please try again.' });
    }
  };

  if (loading) return <div className="text-center my-5">Loading...</div>;

  return (
    <div className="container my-5">
      <h4 className="mb-4 text-center">Edit Renewable Energy Official</h4>

      {successMessage && <div className="alert alert-success text-center">{successMessage}</div>}
      {errors.api && <div className="alert alert-danger text-center">{errors.api}</div>}

      <form onSubmit={handleSubmit} className="shadow p-4 bg-light rounded">
        <div className="row g-3">
          {/* Designation */}
          <div className="col-md-6">
            <label className="form-label">Designation</label>
            <input
              type="text"
              className="form-control"
              name="renergy_officials_designation"
              value={formData.renergy_officials_designation}
              onChange={handleChange}
            />
            {errors.renergy_officials_designation && (
              <small className="text-danger">{errors.renergy_officials_designation}</small>
            )}
          </div>

          {/* Name */}
          <div className="col-md-6">
            <label className="form-label">Official's Name</label>
            <input
              type="text"
              className="form-control"
              name="renergy_officials_name"
              value={formData.renergy_officials_name}
              onChange={handleChange}
            />
            {errors.renergy_officials_name && (
              <small className="text-danger">{errors.renergy_officials_name}</small>
            )}
          </div>

          {/* Email */}
          <div className="col-md-6">
            <label className="form-label">Email (Optional)</label>
            <input
              type="email"
              className="form-control"
              name="renergy_officials_email"
              value={formData.renergy_officials_email}
              onChange={handleChange}
            />
            {errors.renergy_officials_email && (
              <small className="text-danger">{errors.renergy_officials_email}</small>
            )}
          </div>

          {/* Phone */}
          <div className="col-md-6">
            <label className="form-label">Phone (Optional)</label>
            <input
              type="text"
              className="form-control"
              name="renergy_phone"
              value={formData.renergy_phone}
              onChange={handleChange}
            />
            {errors.renergy_phone && <small className="text-danger">{errors.renergy_phone}</small>}
          </div>
        </div>

        <div className="text-center mt-4">
          <button type="submit" className="btn btn-success px-4">
            Update Official
          </button>
        </div>
      </form>
    </div>
  );
}

export default EditEnergyOfficialsPage;
